import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import VueMeta from 'vue-meta'
import Vuelidate from 'vuelidate'
import VueAnalytics from 'vue-analytics';
 

Vue.use(VueAnalytics, {
    id: 'G-JMJPVBMZ6R',
    router
});

Vue.use(Vuelidate);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  VueMeta,
  render: h => h(App)
}).$mount('#app')
